export default __webpack_public_path__ + "static/media/ajanvaraus-white.b64333f1.svg";